import type { TeamFilters } from '../types/team.types';

/**
 * Mapea los filtros de la UI de Equipo al objeto `filter` que espera `user-list`.
 *
 * Contrato parcial: `status` ya lo entiende el endpoint actual
 * (`chikara-user-manager` / `user-list`); `search` (nombre o correo) y `role`
 * corresponden a la extensión de BF-619 (BE, TO DO). Se aísla aquí para
 * ajustar las llaves cuando aterrice esa tarea.
 */
export function buildTeamListFilter(filters: TeamFilters): Record<string, string> {
  const filter: Record<string, string> = {};

  const search = filters.search?.trim();
  if (search) filter.search = search;
  if (filters.role) filter.role = filters.role;
  if (filters.status) filter.status = filters.status;

  return filter;
}

/** ¿Hay algún criterio cargado? Controla el estado del botón "Aplicar filtros". */
export function hasAnyTeamFilter(filters: TeamFilters): boolean {
  return Boolean(filters.search?.trim() || filters.role || filters.status);
}
